import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 1024px) {
    padding: 16px;
  }
  
  @media (max-width: 768px) {
    padding: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  
  @media (max-width: 1024px) {
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin-bottom: 16px;
  }
`;

export const Title = styled.h1`
  color: ${props => props.theme.text};
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  
  @media (max-width: 1024px) {
    font-size: 24px;
  }
  
  @media (max-width: 768px) {
    font-size: 22px;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 1024px) {
    gap: 12px;
    flex-wrap: wrap;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const FilterToggle = styled.div`
  display: flex;
  background-color: ${props => props.theme.background};
  border: 1px solid ${props => props.theme.border};
  border-radius: 6px;
  overflow: hidden;
  
  @media (max-width: 768px) {
    width: 100%;
    order: 1;
  }
`;

export const FilterButton = styled.button<{ active: boolean }>`
  padding: 8px 12px;
  border: none;
  background-color: ${props => props.active ? props.theme.primary : 'transparent'};
  color: ${props => props.active ? props.theme.primaryOn : props.theme.text};
  cursor: pointer;
  transition: all 0.2s;
  font-size: 12px;
  font-weight: 500;
  flex: 1;

  &:hover {
    background-color: ${props => props.active ? props.theme.primary : props.theme.background};
    opacity: ${props => props.active ? '1' : '0.8'};
  }
  
  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 14px;
    min-height: 44px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 12px;
    font-size: 13px;
    min-height: 40px;
  }
`;

export const ViewToggle = styled.div`
  display: flex;
  background-color: ${props => props.theme.background};
  border: 1px solid ${props => props.theme.border};
  border-radius: 6px;
  overflow: hidden;
  
  @media (max-width: 768px) {
    order: 2;
  }
`;

export const ViewButton = styled.button<{ active: boolean }>`
  padding: 8px 12px;
  border: none;
  background-color: ${props => props.active ? props.theme.primary : 'transparent'};
  color: ${props => props.active ? props.theme.primaryOn : props.theme.text};
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${props => props.active ? props.theme.primary : props.theme.background};
    opacity: ${props => props.active ? '1' : '0.8'};
  }
  
  @media (max-width: 768px) {
    padding: 12px 16px;
    min-height: 44px;
    min-width: 44px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 12px;
    min-height: 40px;
    min-width: 40px;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid ${props => props.theme.border};
  border-radius: 6px;
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.text};
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
  }
  
  &::placeholder {
    color: ${props => props.theme.textSecondary};
  }
  
  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 16px;
    border-radius: 8px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 14px;
    font-size: 14px;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 16px 0;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
    padding: 12px 0;
  }
`;

export const PaginationInfo = styled.span`
  color: ${props => props.theme.textSecondary};
  font-size: 14px;
  
  @media (max-width: 768px) {
    font-size: 13px;
    text-align: center;
    order: 2;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const PaginationButtons = styled.div`
  display: flex;
  gap: 8px;
  
  @media (max-width: 768px) {
    order: 1;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
  }
`;

export const PaginationButton = styled.button<{ active?: boolean; disabled?: boolean }>`
  padding: 8px 12px;
  border: 1px solid ${props => props.theme.border};
  border-radius: 4px;
  background-color: ${props => 
    props.active ? props.theme.primary : 
    props.disabled ? props.theme.backgroundAlt : 
    props.theme.background
  };
  color: ${props => 
    props.active ? props.theme.text : 
    props.disabled ? props.theme.textSecondary : 
    props.theme.text
  };
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 14px;
  transition: all 0.2s;
  
  &:hover:not(:disabled) {
    background-color: ${props => props.active ? props.theme.primary : props.theme.backgroundAlt};
  }
  
  &:disabled {
    opacity: 0.5;
  }
  
  @media (max-width: 768px) {
    padding: 10px 14px;
    font-size: 15px;
    min-height: 40px;
    min-width: 40px;
  }
  
  @media (max-width: 480px) {
    padding: 8px 12px;
    font-size: 14px;
    min-height: 36px;
    min-width: 36px;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }

  svg {
    flex-shrink: 0;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    padding: 12px 16px;
    font-size: 16px;
    min-height: 48px;
    order: 3;
  }
  
  @media (max-width: 480px) {
    padding: 10px 14px;
    font-size: 14px;
    min-height: 44px;
  }
`;

export const FoldersContainer = styled.div<{ viewMode: 'grid' | 'list' }>`
  display: ${props => props.viewMode === 'grid' ? 'grid' : 'flex'};
  ${props => props.viewMode === 'grid' 
    ? `
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 20px;
    `
    : `
      flex-direction: column;
      gap: 8px;
    `
  }
  flex: 1;
  
  @media (max-width: 1024px) {
    ${props => props.viewMode === 'grid' 
      ? `
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 16px;
      `
      : `
        gap: 6px;
      `
    }
  }
  
  @media (max-width: 768px) {
    ${props => props.viewMode === 'grid' 
      ? `
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 12px;
      `
      : `
        gap: 8px;
      `
    }
  }
  
  @media (max-width: 480px) {
    ${props => props.viewMode === 'grid' 
      ? `
        grid-template-columns: 1fr;
        gap: 12px;
      `
      : `
        gap: 6px;
      `
    }
  }
`;

export const FolderCard = styled.div<{ viewMode: 'grid' | 'list' }>`
  display: flex;
  ${props => props.viewMode === 'grid' 
    ? `
      flex-direction: column;
      padding: 20px;
      min-height: 160px;
    `
    : `
      flex-direction: row;
      align-items: center;
      padding: 12px 16px;
      min-height: 60px;
    `
  }
  background-color: ${props => props.theme.background};
  border: 1px solid ${props => props.theme.border};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: ${({ theme }) => theme.primaryAccent};
  }
  
  @media (max-width: 1024px) {
    ${props => props.viewMode === 'grid' 
      ? `
        padding: 16px;
        min-height: 140px;
      `
      : `
        padding: 10px 14px;
        min-height: 56px;
      `
    }
  }
  
  @media (max-width: 768px) {
    ${props => props.viewMode === 'grid' 
      ? `
        padding: 16px;
        min-height: 120px;
      `
      : `
        padding: 12px 16px;
        min-height: 60px;
        flex-wrap: wrap;
        gap: 8px;
      `
    }
    
    &:hover {
      transform: none;
    }
  }
  
  @media (max-width: 480px) {
    ${props => props.viewMode === 'grid' 
      ? `
        padding: 12px;
        min-height: 100px;
      `
      : `
        padding: 10px 12px;
        min-height: 56px;
      `
    }
  }
`;

export const FolderIcon = styled.div`
  color: ${({ theme }) => theme.primaryAccent};
  margin-bottom: 12px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    margin-bottom: 8px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 6px;
  }
`;

export const FolderInfo = styled.div`
  flex: 1;
`;

export const FolderName = styled.h3`
  color: ${props => props.theme.text};
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 15px;
    margin: 0 0 6px 0;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    margin: 0 0 4px 0;
  }
`;

export const FolderDetails = styled.div`
  color: ${props => props.theme.textSecondary};
  font-size: 12px;
  line-height: 1.4;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
  }
`;

export const FolderActions = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s;

  ${FolderCard}:hover & {
    opacity: 1;
  }
  
  @media (max-width: 768px) {
    position: static;
    opacity: 1;
    justify-content: center;
    width: 100%;
    margin-top: 8px;
    gap: 8px;
    order: 3;
  }
`;

export const ActionIcon = styled.button<{ danger?: boolean; primary?: boolean; success?: boolean }>`
  width: 32px;
  height: 32px;
  border: none;
  background-color: ${props => props.theme.background};
  color: ${props => 
    props.danger ? props.theme.error : 
    props.primary ? props.theme.primaryAccent : 
    props.success ? props.theme.success : 
    props.theme.textSecondary
  };
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${props => 
      props.danger ? props.theme.error : 
      props.primary ? props.theme.primary : 
      props.success ? props.theme.success : 
      props.theme.primary
    };
    color: ${({ theme }) => theme.primaryOn};
  }
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
  
  @media (max-width: 480px) {
    width: 36px;
    height: 36px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: ${props => props.theme.textSecondary};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: ${props => props.theme.textSecondary};
  text-align: center;
  padding: 20px;

  svg {
    margin-bottom: 16px;
    opacity: 0.5;
  }

  h3 {
    color: ${props => props.theme.text};
    margin: 0 0 8px 0;
    font-size: 18px;
  }

  p {
    margin: 0 0 24px 0;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    height: 250px;
    padding: 16px;
    
    h3 {
      font-size: 16px;
    }
    
    p {
      font-size: 13px;
      margin: 0 0 20px 0;
    }
  }
  
  @media (max-width: 480px) {
    height: 200px;
    padding: 12px;
    
    h3 {
      font-size: 15px;
    }
    
    p {
      font-size: 12px;
      margin: 0 0 16px 0;
    }
  }
`;

// Modal Styles
export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${props => props.theme.background};
  border-radius: 8px;
  border: 1px solid ${props => props.theme.border};
  width: 500px;
  max-width: 90vw;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    width: 95vw;
    max-height: 85vh;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    width: 98vw;
    max-height: 90vh;
    border-radius: 8px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid ${props => props.theme.border};
  
  @media (max-width: 768px) {
    padding: 16px 20px 12px;
  }
  
  @media (max-width: 480px) {
    padding: 14px 16px 10px;
  }
`;

export const ModalTitle = styled.h2`
  color: ${props => props.theme.text};
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
  
  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

export const ModalCloseButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background-color: transparent;
  color: ${props => props.theme.textSecondary};
  border-radius: 4px;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background-color: ${props => props.theme.background};
    opacity: 0.8;
  }
`;

export const ModalBody = styled.div`
  padding: 20px 24px;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
  
  @media (max-width: 480px) {
    padding: 14px 16px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FormLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  color: ${props => props.theme.text};
  font-size: 14px;
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 8px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 6px;
  }
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${props => props.theme.border};
  border-radius: 6px;
  background-color: ${props => props.theme.input?.background || props.theme.background};
  color: ${props => props.theme.text};
  font-size: 14px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
  }

  &::placeholder {
    color: ${props => props.theme.textSecondary};
  }
  
  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 16px;
    border-radius: 8px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 14px;
    font-size: 14px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 20px;
  border-top: 1px solid ${props => props.theme.border};
  
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 8px;
    padding: 12px 20px 16px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 16px 14px;
  }
`;

export const CancelButton = styled.button`
  padding: 8px 16px;
  border: 1px solid ${props => props.theme.border};
  border-radius: 6px;
  background-color: transparent;
  color: ${props => props.theme.text};
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;

  &:hover {
    background-color: ${props => props.theme.background};
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 48px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 10px 16px;
    font-size: 14px;
    min-height: 44px;
  }
`;

export const ConfirmButton = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.primary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 48px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 10px 16px;
    font-size: 14px;
    min-height: 44px;
  }
`;

// Permissions Styles
export const PermissionsList = styled.div`
  margin-top: 16px;
  max-height: 200px;
  overflow-y: auto;
`;

export const PermissionItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 4px;
  background-color: ${props => props.theme.background};
  border-radius: 4px;
  border: 1px solid ${props => props.theme.border};
`;

export const UserName = styled.span`
  color: ${props => props.theme.text};
  font-weight: 500;
`;

export const PermissionLevel = styled.span<{ level: 'read' | 'write' | 'admin' }>`
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.primaryOn};
  background-color: ${props => 
    props.level === 'admin' ? props.theme.error :
    props.level === 'write' ? props.theme.warning :
    props.theme.success
  };
`; 
/*
 * Banner de mensagem da listagem de pastas.
 *
 * Existia só na página de DETALHES; aqui o `catch` do upload fazia apenas `console.error`, então
 * falha de upload era invisível para o usuário — a dor #1 registrada no projeto. Tokens do tema,
 * nunca cor literal (ver `scripts/gate-tema.mjs`).
 */
export const ErrorMessage = styled.div`
  padding: 12px 16px;
  border-radius: 8px;
  color: ${props => props.theme.error};
  background-color: ${props => props.theme.errorBackground};
  border: 1px solid ${props => props.theme.error};
  font-size: 14px;
  line-height: 1.4;
`;

export const SuccessMessage = styled.div`
  padding: 12px 16px;
  border-radius: 8px;
  color: ${props => props.theme.success};
  background-color: ${props => props.theme.successBackground};
  border: 1px solid ${props => props.theme.success};
  font-size: 14px;
  line-height: 1.4;
`;
